import { NavLink, useNavigate } from 'react-router-dom';
import { LockKey, SignOut } from '@phosphor-icons/react';
import { GROUPS, ITEMS } from './navConfig';

export const SidebarNav = ({ user, items, chatUnread, mobileNav, setMobileNav, t, logout }) => {
  const nav = useNavigate();
  return (
    <aside className={`fixed z-50 inset-y-0 start-0 w-64 bg-white border-e border-slate-200 flex-col ${mobileNav ? 'flex' : 'hidden'} md:flex`}>
      <div className="h-16 flex items-center gap-2.5 px-5 border-b border-slate-200">
        <img src="/brand/onrid-icon.png" alt="ONRID" className="w-9 h-9 rounded-lg object-contain ring-1 ring-orange-100" data-testid="brand-icon" />
        <span className="font-display font-extrabold tracking-tight text-lg">ONRID</span>
      </div>
      <nav className="flex-1 py-3 px-3 overflow-y-auto">
        {GROUPS.map((g) => {
          const groupItems = g.keys.filter((k) => items.some((it) => it && it.to === ITEMS[k]?.to)).map((k) => ITEMS[k]);
          if (!groupItems.length) return null;
          return (
            <div key={g.label} className="mb-1.5" data-testid={`nav-group-${g.label.toLowerCase()}`}>
              {g.label !== 'Overview' && <p className="font-mono-label text-[9px] uppercase tracking-widest text-slate-400 px-3 pt-2.5 pb-1">{t(g.label)}</p>}
              {groupItems.map(({ to, label, icon: Icon }) => (
                <NavLink key={to} to={to} end={to === '/'} onClick={() => setMobileNav(false)} data-testid={`nav-${label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
                  className={({ isActive }) => `group relative flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium press ${isActive ? 'bg-orange-50 text-orange-700 font-semibold' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'}`}>
                  {({ isActive }) => (<>
                    {isActive && <span className="absolute start-0 top-1.5 bottom-1.5 w-1 rounded-full bg-orange-500" />}
                    <Icon size={18} weight={isActive ? 'fill' : 'duotone'} className={isActive ? 'text-orange-600' : ''} /> {t(label)}
                    {to === '/chat' && chatUnread?.unread > 0 && (
                      <span data-testid="chat-unread-badge" className="ms-auto bg-orange-500 text-white text-[10px] rounded-full px-1.5 py-0.5 font-bold">{chatUnread.unread}</span>
                    )}
                  </>)}
                </NavLink>
              ))}
            </div>
          );
        })}
      </nav>
      <div className="p-4 border-t border-slate-200">
        <div className="flex items-center gap-2">
          {user?.photo_path
            ? <img src={`${process.env.REACT_APP_BACKEND_URL}/api/people/user/${user.id}/photo`} alt="" data-testid="shell-avatar" className="w-8 h-8 rounded-full object-cover border border-slate-200" />
            : <div className="w-8 h-8 rounded-full bg-orange-100 text-orange-700 flex items-center justify-center text-xs font-bold" data-testid="shell-avatar-initials">{(user?.name || '?').split(' ').map((x) => x[0]).slice(0, 2).join('')}</div>}
          <div className="min-w-0">
            <p className="text-sm font-semibold truncate" data-testid="shell-user-name">{user?.name}</p>
            <p className="font-mono-label text-[10px] uppercase text-slate-400">{user?.role?.replace(/_/g, ' ')}</p>
          </div>
        </div>
        <NavLink to="/profile" data-testid="security-mfa-link" onClick={() => setMobileNav(false)} className="mt-3 flex items-center gap-2 text-xs text-slate-500 hover:text-slate-900 transition-colors">
          <LockKey size={14} /> {t('Security & MFA')} {user?.mfa_enabled && <span className="text-green-700">✓</span>}
        </NavLink>
        <button data-testid="logout-button" onClick={() => { logout(); nav('/login'); }} className="mt-2 flex items-center gap-2 text-xs text-slate-500 hover:text-rose-600 transition-colors">
          <SignOut size={14} /> {t('Sign out')}
        </button>
      </div>
    </aside>
  );
};
